module.exports = __webpack_public_path__ + "static/img/independent1.d6c7be1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/independent1.png
// module id = OCk9
// module chunks = 1